import React from "react";
import Plot from "react-plotly.js";

const StripPlot = ({data}) => {

  const plotData = [
    {
      x: data,
      type: "scatter",
      mode: "markers",
      marker: {
        size: 10,
        color: "navyblue",
      },
    },
  ];

  const layout = {
    title: "<b>Strip Plot</b>",
    xaxis: {
      title: "values",
    },
    yaxis: {
      title: "Counts",
    },
    autosize: true
  };

  return <Plot data={plotData} layout={layout}  style={{ width: "100%", height: "100%" }} />;
};

export default StripPlot;
